/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorPeriodType = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The PerformanceIndicatorPeriodType model module.
   * @module model/PerformanceIndicatorPeriodType
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PerformanceIndicatorPeriodType</code>.
   * @alias module:model/PerformanceIndicatorPeriodType
   * @class
   */
  var exports = function() {
    var _this = this;









  };

  /**
   * Constructs a <code>PerformanceIndicatorPeriodType</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PerformanceIndicatorPeriodType} obj Optional instance to populate.
   * @return {module:model/PerformanceIndicatorPeriodType} The populated <code>PerformanceIndicatorPeriodType</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('Adverb')) {
        obj['Adverb'] = ApiClient.convertToType(data['Adverb'], 'String');
      }
      if (data.hasOwnProperty('Adjective')) {
        obj['Adjective'] = ApiClient.convertToType(data['Adjective'], 'String');
      }
      if (data.hasOwnProperty('Abbreviation')) {
        obj['Abbreviation'] = ApiClient.convertToType(data['Abbreviation'], 'String');
      }
      if (data.hasOwnProperty('NPeriods')) {
        obj['NPeriods'] = ApiClient.convertToType(data['NPeriods'], 'String');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('Identifier')) {
        obj['Identifier'] = ApiClient.convertToType(data['Identifier'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {String} Adverb
   * @default ''
   */
  exports.prototype['Adverb'] = '';
  /**
   * @member {String} Adjective
   * @default ''
   */
  exports.prototype['Adjective'] = '';
  /**
   * @member {String} Abbreviation
   * @default ''
   */
  exports.prototype['Abbreviation'] = '';
  /**
   * @member {String} NPeriods
   * @default ''
   */
  exports.prototype['NPeriods'] = '';
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {String} Identifier
   * @default ''
   */
  exports.prototype['Identifier'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


